import { setLanguage } from "config/language";
import Banner from "../common/Banner";
import { useEffect, useState } from "react";
import BazAIHelmet from "../common/BazAIHelmet";
import { baseUrl } from "config/apiUrl";
import { arPageData, arFAQs } from "./ARdata";
import UpdateNavbar from "pages/UpdatedLanding/Common/UpdateNavbar";
import UpdateFooter from "pages/UpdatedLanding/Common/UpdateFooter";
import EnhancedPageLayout from "pages/UpdatedLanding/Common/EnhancedPageLayout";

export default function LandingForARAutomation() {
  const [scrollTop, setScrollTop] = useState(0);
  useEffect(() => {
    function onScroll() {
      setScrollTop(document.documentElement.scrollTop);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);
  if (localStorage.getItem("lan") === null) {
    setLanguage();
  }

  return (
    <div className="bg-slate-50 min-h-screen">
      <BazAIHelmet
        title="AR Automation Software — Automate Invoicing and Payment Collection"
        description="EkkBaz AI AR Automation eliminates manual accounts receivable work — automating invoicing, payment reminders, and reconciliation to reduce DSO by 40% and recover 95% of overdue payments automatically."
        keywords="AR automation software, accounts receivable automation, invoice automation, payment reconciliation AI, reduce DSO, automated payment reminders, B2B collections software"
        image="/assets/images/LogoAI.png"
        url={`${baseUrl.webUrl}/product/ar-automation`}
        productName="AR Automation"
        faqItems={arFAQs}
      />
      <UpdateNavbar />
      <Banner
        headline="AR Automation"
        subtitle="Eliminate manual accounts receivable work. Automate invoicing, reminders, and reconciliation — reducing DSO by 40% from day one."
        from="ar-automation"
      />
      <EnhancedPageLayout {...arPageData} />
      <UpdateFooter />
    </div>
  );
}
